import type { LocationDescriptor } from 'history';
import type { HTMLAttributes, MouseEventHandler } from 'react';

export interface CardItemArticleTag {
  label: string;
  color?: string;
}

export interface CardItemArticleData {
  image?: string;
  title: string;
  tags?: CardItemArticleTag[];
  reviewed?: boolean;
  link?: LocationDescriptor;
  onClick?: MouseEventHandler;
  loading?: boolean;
  lazyLoadImage?: boolean;
}

export interface CardItemArticleProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'onClick' | 'title'>,
    CardItemArticleData {}
